import React, { useState, useEffect, useRef, useMemo } from 'react';
import classnames from 'classnames';
import { Icon, Wrapper } from '@/components';
import { i18n, thumbnail7n, priceFormat } from '@/utils';
import { RelatedProductIncrement } from '../increment';
import styles from './style.less';

interface relatedProductProps {
  /** vip 增值服务 */
  data?: RelatedProductIncrement[];
  /** 货币符号 */
  currencySymbol?: string;
  /** 谷歌分析 */
  gtag: any;
  /** 关闭回调 */
  onClose(): void;
  /** 确认回调 */
  onConfirm: (product?: RelatedProductIncrement) => void;
}

const relatedProduct: React.FC<relatedProductProps> = ({
  data = [],
  currencySymbol,
  onClose,
  onConfirm
}) => {

  const _video = useRef<HTMLVideoElement>(null);
  /** 激活产品 */
  const [ currentProduct, setCurrentProduct ] = useState<RelatedProductIncrement | undefined>(data[0]);
  /** 重试显隐 */
  const [ retryVisible, setRetryVisible ] = useState<boolean>(false);

  /** 最低价格 */
  const _price = useMemo(() => {
    return Math.min(...data.map(item => item.price));
  },[ data ]);

  const _end = useMemo(() => {
    return data.find(item => item.price !== _price) ? '+' : '';
  }, [ _price ])

  /** 视频加载完成触发 */
  const handleVideoRetry = () => {
    _video.current?.play();
    setRetryVisible(false);
  }

  return (
    <div className={styles.relatedProduct}>
      <div
        className={styles.closeWrapper}
        onClick={onClose}
      >
        <Icon type="close" size={30} />
      </div>
      <div className={styles.content}>
        <div className={styles.title}>{i18n.format('increment.related.product.title')}</div>
        <div className={styles.priceWrapper}>
          {currentProduct ? (
            <span className={classnames(styles.price, styles.priceActive)}>
              {/* + {currencySymbol}{currentProduct.price} */}
              + {priceFormat(currencySymbol!, currentProduct.price)}
            </span>
          ) : (
            <span className={styles.price}>
              {/* {currencySymbol}{_price}{_end} */}
              {priceFormat(currencySymbol!, _price)}{_end}
            </span>
          )}
        </div>
        <div className={styles.tab}>
          {data.map(item =>
            <div
              key={item.id}
              className={classnames(styles.tabKey, {
                [styles.tabKeyActive]: item.id === currentProduct?.id
              })}
              style={{
                backgroundImage: `url(${thumbnail7n(item.thumbnail, 160)})`
              }}
              onClick={() => setCurrentProduct(item)}
            >
              <Icon className={styles.activeCorner} type="select-corner" size={30} />
              <Icon className={styles.activeCornerCheck} type="confirm" size={10} />
            </div>
          )}
          <div
            className={classnames(styles.tabKey, {
              [styles.tabKeyActive]: currentProduct === undefined
            })}
            style={{
              backgroundImage: `url(${require('@/assets/nothanks.png')})`
            }}
            onClick={() => setCurrentProduct(undefined)}
          >
            <Icon className={styles.activeCorner} type="select-corner" size={30} />
            <Icon className={styles.activeCornerCheck} type="confirm" size={10} />
          </div>
        </div>
        <div className={styles.tabContent}>
          <div className={styles.videoContent}>
            <video
              ref={_video}
              src={currentProduct?.video}
              playsInline
              muted
              autoPlay
              onEnded={() => setRetryVisible(true)}
            />
            {retryVisible &&
              <div
                className={styles.retry}
                onClick={handleVideoRetry}
              >
                <Icon type="rotate-left" size={20} />
              </div>
            }
            {currentProduct === undefined &&
              <Wrapper className={styles.nothanksWrapper}>
                <div className={styles.nothanks}>
                  <span>{i18n.format('increment.related.product.no.thanks')} ! 😅</span>
                </div>
              </Wrapper>
            }
          </div>
        </div>
      </div>
      <div
        className={styles.footer}
        onClick={() => onConfirm(currentProduct)}
      >
        {i18n.format('modules.global.add.cart')}
      </div>
    </div>
  )
}

export default relatedProduct;
